<template>
  <h1>欢迎使用，请联系管理员配置你的角色菜单</h1>
</template>
<script>
export default {

}
</script>
<style>

</style>